'use client';

import { AccountDrawerType, usePageLayout } from '@libs/common-next';
import { Grid, TextLink } from '@petsmart-ui/sparky';

export type ForgotPasswordCtaProps = {
    componentClassname?: string;
    webUrl?: string;
    actionText?: string;
};

export function ForgotPasswordCta({ componentClassname, webUrl, actionText }: Readonly<ForgotPasswordCtaProps>) {
    const { openAccountDrawer } = usePageLayout();

    return (
        <Grid.Item className={`${componentClassname}__forgot-password`}>
            <TextLink
                href={webUrl ?? '#'}
                data-testid="forgot-password-link"
                onClick={() => {
                    if (!webUrl) {
                        openAccountDrawer(AccountDrawerType.FORGOT_PASSWORD);
                    }
                }}
            >
                {actionText ?? 'Forgot password?'}
            </TextLink>
        </Grid.Item>
    );
}
